// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import 'vuetify/styles'
// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify(
    {
        theme: {
            options: {
                customProperties: true,
            },
            fonts: {
                body: 'Verdana, sans-serif',
                heading: 'Verdana, sans-serif',
            },
        },
    }
)
